<ngb-pagination
    [collectionSize]="totalSize"
    [page]="currentPage"
    [pageSize]="pageSize"
    [boundaryLinks]="totalSize > 5"
    [maxSize]="5"
    [rotate]="true"
    (pageChange)="_onPageChange($event)"
    aria-label="Pagination"
>
    <ng-template ngbPaginationNumber let-page *ngIf="pageLink"
        ><a href="{{ pageLink + '?page=' + page }}">{{ page }}</a></ng-template
    >
</ngb-pagination>
